import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { T } from "services/lang/LanguageService";

const GLOBAL_CONFIRM_DIALOG_EVENT_NAME = "EasasGlobalConfirmDialogEvent";

type ConfirmDialogOptions = {
  icon?: string;
  header: string;
  message?: string;
  acceptClassName?: string;
  acceptText?: string;
  cancelClassName?: string;
  cancelText?: string;
  confirmedCallback: () => void;
};

const defaultConfirmDialogOptions: ConfirmDialogOptions = {
  icon: "",
  header: T("action.confirm-action"),
  message: T("alert.are-you-sure-you-want-to-proceed"),
  acceptClassName: "p-button-danger",
  acceptText: T("word.yes"),
  cancelClassName: "p-button-text",
  cancelText: T("word.no"),
  confirmedCallback: () => {},
};

const EasasGlobalConfirmDialog = () => {
  const [visible, setVisible] = useState(false);
  const [dialogProps, setDialogProps] = useState<ConfirmDialogOptions>(defaultConfirmDialogOptions);
  
  useEffect(() => {
    const listener = (e: EasasGlobalConfirmDialogEvent) => {
        setDialogProps({
            ...defaultConfirmDialogOptions,
            ...e.detail,
          });
      setVisible(true);
    };

    window.addEventListener(GLOBAL_CONFIRM_DIALOG_EVENT_NAME, listener as EventListener);
    return () =>
      window.removeEventListener(GLOBAL_CONFIRM_DIALOG_EVENT_NAME, listener as EventListener);
  }, []);

  const footer = () => (
    <div>
      <Button
        onClick={() => setVisible(false)}
        label={dialogProps.cancelText}
        className={dialogProps.cancelClassName}
      />
      <Button
        onClick={() => {
          dialogProps.confirmedCallback();
          setVisible(false);
        }}
        label={dialogProps.acceptText}
        className={dialogProps.acceptClassName}
      />
    </div>
  );

  return (
    <Dialog
      onHide={() => setVisible(false)}
      visible={visible}
      header={dialogProps.header}
      footer={footer}
      className="w-max h-3"
    >
      <div className="flex flex-column gap-1">
        <div className="flex align-items-center">
          {dialogProps.icon && (
            <i className={dialogProps.icon} style={{ fontSize: "2em", marginRight: "0.5em" }} />
          )}
          <span>{dialogProps.message}</span>
        </div>
      </div>
    </Dialog>
  );
};

export default EasasGlobalConfirmDialog;

class EasasGlobalConfirmDialogEvent extends CustomEvent<ConfirmDialogOptions> {
  constructor(detail: ConfirmDialogOptions) {
    super(GLOBAL_CONFIRM_DIALOG_EVENT_NAME, { detail });
  }
}

export function easasConfirmDialog(options: ConfirmDialogOptions) {
  dispatchEvent(new EasasGlobalConfirmDialogEvent(options));
}
